import { render, staticRenderFns } from "./DashboardBannerHeader.vue?vue&type=template&id=6f974980&scoped=true&"
import script from "./DashboardBannerHeader.vue?vue&type=script&lang=js&"
export * from "./DashboardBannerHeader.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBannerHeader.vue?vue&type=style&index=0&id=6f974980&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f974980",
  null
  
)

export default component.exports